import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (!data?.nome?.length > 0)
        response.push(<Box>Digite o nome do acesso.</Box>)

    if (data?.alas.length === 0)
        response.push(<Box>Selecione uma ala.</Box>)

    if (data?.pisos.length === 0)
        response.push(<Box>Selecione um piso.</Box>)

    if (data?.catracas.length === 0)
        response.push(<Box>Selecione uma catraca.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData